module.exports = __webpack_public_path__ + "media/images/frontend/menu-61aa2a49da3200fa9e8655e032e820db.svg";